<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="cs-head">
        <span class="cs-bar cs-bar--title"></span>
        <span class="cs-bar cs-bar--subtitle"></span>
      </div>
      <div class="cs-body">
        <span class="cs-bar cs-bar--line"></span>
        <span class="cs-bar cs-bar--line"></span>
        <span class="cs-bar cs-bar--line cs-bar--short"></span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewContentSlide',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.cs-bar {
  display: block;
  height: 8px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.cs-head {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 22%, transparent);
}
.cs-bar--title {
  height: 14px;
  width: 60%;
  background: rgba(15, 15, 20, 0.22);
}
.cs-bar--subtitle {
  width: 38%;
  background: rgba(15, 15, 20, 0.14);
}
.cs-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}
.cs-bar--line { width: 90%; }
.cs-bar--short { width: 60%; }
</style>
